import { compact, map, pad, range } from 'lodash';

const SHORT_HAND = {
  hours: 'hr',
  minutes: 'min',
  seconds: 'sec',
};

export const yearDigits = parseInt(
  new Date()
    .getFullYear()
    .toString()
    .slice(-2),
  10
);

export const digitalToSeconds = minutes => {
  var parts = minutes.split(':');
  return parseInt(parts[0]) * 60 + parseInt(parts[1]);
};

export const format = (data, type) => {
  if (type === 'digital') {
    return formatDigital(data);
  } else if (type === 'minutes') {
    return formatMinutes(data);
  } else if (type === 'seconds') {
    return digitalToSeconds(data);
  } else {
    return formatVerbose(data);
  }
};

export const formatDigital = ({ hours, minutes, seconds }) => {
  const time = [];

  if (hours > 0) {
    time.push(hours);
    time.push(pad(minutes, 2, '0'));
  } else if (minutes > 0) {
    time.push(minutes);
  } else {
    time.push('0');
  }

  time.push(pad(seconds, 2, '0'));

  return time.join(':');
};

export const formatMinutes = ({ hours, minutes }) => {
  let time = 0;

  if (hours > 0) {
    time += hours * 60;
  }

  if (minutes > 0) {
    time += minutes;
  }

  return `${time} mins`;
};

export const formatVerbose = data => {
  let items = map(data, (value, type) => {
    if (value > 0) {
      return `${value} ${SHORT_HAND[type]}`;
    }
  });

  return compact(items).join(' ');
};

export const formatDateString = date => {
  const year = date.getFullYear();
  const month = padNumber(date.getMonth() + 1);
  const day = padNumber(date.getDate());
  return `${year}-${month}-${day}`;
};

export const padNumber = n => {
  return n < 10 ? '0' + n : '' + n;
};

export const datesForWeek = () => {
  const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];

  const today = new Date();

  return map(range(0, 7), i => {
    const date = new Date();

    let title;
    date.setDate(today.getDate() + i);

    if (i === 0) {
      title = 'Today';
    } else if (i === 1) {
      title = 'Tomorrow';
    } else {
      title = days[date.getDay()];
    }

    return {
      title,
      startDate: formatDateString(date),
    };
  });
};



// WEBPACK FOOTER //
// ./src/utils/timeFormat.js